import { useState } from "react";
import { Container } from "reactstrap";
import All from "./All/All";
import StoreCredit from "./StoreCredit/StoreCredit";
import GiftVoucher from "./GiftVoucher/GiftVoucher";

const Vouchers = () => {
  const tabs = ["All", "Store Credit", "Gift Voucher"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <Container fluid className="g-0">
      <div className="d-flex mb-3 gap-3 overflow-x-auto text-nowrap">
        {tabs.map((tab) => (
          <div
            className="fw-semibold"
            style={{
              color: tab === activeTab ? "#EC7426" : "black",
              cursor: "pointer",
              transition: "color 1s ease",
              fontSize: "1rem",
              padding: ".5rem 0rem",
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === "All" && <All />}
      {activeTab === "Store Credit" && <StoreCredit />}
      {activeTab === "Gift Voucher" && <GiftVoucher />}
    </Container>
  );
};

export default Vouchers;